// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#infoTable tr td:first-child {
  padding-right: 15px;
}

@media (min-width: 1235px) {
  .nav-tabs > li.active > a, .nav-tabs > li.active > a:focus, .nav-tabs > li.active > a:hover {
    background-color: white;
  }
}
@media (min-width: 1px) and (max-width: 1234px) {
  .nav-tabs > li.active > a, .nav-tabs > li.active > a:focus, .nav-tabs > li.active > a:hover {
    background-color: white;
  }
}
.topHead {
  height: 70px;
}

/**
@media (max-height:  725px ) {
    #informations {
        display: none;
    }
    #informationAltTitle {
        display: block !important;
    }
}

#informationAltTitle {
    display: none;
}

*/
/** affixing **/
.top {
  background-color: #F7F5F2;
  top: 0;
}

.fluid {
  position: relative;
  top: 125px;
}

.semiFluid {
  position: relative;
  top: 125px;
}

.blockBottom {
  position: fixed;
  padding-top: 20px;
}

.bbLeft {
  left: 102px;
  padding: 35px 20px 0 20px;
}

.bbRight {
  padding-right: 40px;
}

#individusListing {
  width: 100%;
}

#individusListing tr th {
  padding-bottom: 8px;
}

#individusListing tr td,
#individusListing tr th {
  width: 20%;
  text-align: center;
}

#individusListing tr td:first-child,
#individusListing tr th:first-child {
  width: 60%;
  text-align: left;
}

.topMenu, .bottomMenu {
  background-color: #EDF2F5;
  margin: 0 0 auto 102px;
  min-width: 550px;
}

.topMenu {
  padding-top: 20px;
  border-bottom: 1px solid #ddd;
  padding-left: 20px;
}

.bottomMenu {
  padding-top: 5px;
  border-top: 1px solid #ddd;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/graphboards/components/web/graphboards-sidebar/graphboards-sidebar.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI;IACI,uBAAA;EACN;AACF;AAEA;EACI;IACI,uBAAA;EAAN;AACF;AAGA;EACI,YAAA;AADJ;;AAIA;;;;;;;;;;;;;;CAAA;AAgBA,eAAA;AAEA;EACI,yBAAA;EACA,MAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,UAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,UAAA;AAHJ;;AAMA;EACI,eAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,yBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;;EAGI,UAAA;EACA,kBAAA;AAJJ;;AASA;;EAEI,UAAA;EACA,gBAAA;AANJ;;AASA;EACI,yBAAA;EACA,sBAAA;EACA,gBAAA;AANJ;;AASA;EACI,iBAAA;EACA,6BAAA;EACA,kBAAA;AANJ;;AASA;EACI,gBAAA;EACA,0BAAA;AANJ","sourcesContent":["#infoTable tr td:first-child {\n    padding-right: 15px;\n}\n\n@media(min-width: 1235px) {\n    .nav-tabs > li.active > a, .nav-tabs > li.active > a:focus, .nav-tabs > li.active > a:hover {\n        background-color: white;\n    }\n}\n\n@media(min-width: 1px) and (max-width: 1234px) {\n    .nav-tabs > li.active > a, .nav-tabs > li.active > a:focus, .nav-tabs > li.active > a:hover {\n        background-color: white;\n    }\n}\n\n.topHead {\n    height: 70px;\n}\n\n/**\n@media (max-height:  725px ) {\n    #informations {\n        display: none;\n    }\n    #informationAltTitle {\n        display: block !important;\n    }\n}\n\n#informationAltTitle {\n    display: none;\n}\n\n*/\n\n/** affixing **/\n\n.top {\n    background-color: #F7F5F2;\n    top: 0;\n}\n\n.fluid {\n    position: relative;\n    top: 125px;\n}\n\n.semiFluid {\n    position: relative;\n    top: 125px;\n}\n\n.blockBottom {\n    position: fixed;\n    padding-top: 20px;\n}\n\n.bbLeft {\n    left: 102px;\n    padding: 35px 20px 0 20px;\n}\n\n.bbRight {\n    padding-right: 40px;\n}\n\n#individusListing {\n    width: 100%;\n}\n\n#individusListing tr th {\n    padding-bottom: 8px;\n}\n\n#individusListing tr td,\n#individusListing tr th\n{\n    width: 20%;\n    text-align: center;\n}\n\n\n\n#individusListing tr td:first-child,\n#individusListing tr th:first-child {\n    width: 60%;\n    text-align: left;\n}\n\n.topMenu, .bottomMenu {\n    background-color: #EDF2F5;\n    margin: 0 0 auto 102px;\n    min-width: 550px;\n}\n\n.topMenu {\n    padding-top: 20px;\n    border-bottom: 1px solid #ddd;\n    padding-left: 20px;\n}\n\n.bottomMenu {\n    padding-top: 5px;\n    border-top: 1px solid #ddd;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
